export function reloadPageOnErrorFn(): void {
  window.location.reload()
}
